import React, { useState } from 'react';
import './Header.scss';
import logo from '../../assets/icons/hat-monogram.svg';
import HatPdaDialog from '../shared/HatPdaDialog';
import { Routes, SandboxRoutes } from '../../app/AppRouter';
import { useSelector } from 'react-redux';
import { selectSandbox } from '../../features/sandbox/sandboxSlice';
import { useHistory } from 'react-router';

type Props = {
  loginBtn: boolean;
  signupBtn: boolean;
};
export const Header: React.FC<Props> = (props) => {
  const history = useHistory();
  const [state, setState] = useState({ showDialog: false, open: false });
  const sandbox = useSelector(selectSandbox);

  const switchDialog = (dialogState: boolean) => {
    setState({ ...state, open: dialogState });
  };

  const navigateToSignup = () => {
    const navigateUri = sandbox ? SandboxRoutes.hatSignup : Routes.hatSignup;
    history.push(navigateUri + window.location.search);
  };

  const navigateToLogin = () => {
    const navigateUri = sandbox ? SandboxRoutes.hatLogin : Routes.hatLogin;
    history.push(navigateUri + window.location.search);
  };

  const onWhatsHatPdaClicked = () => {
    setState({ ...state, open: true });
  };

  const navigateToHome = () => {
    const navigateUri = sandbox ? SandboxRoutes.home : Routes.home;
    history.push(navigateUri + window.location.search);
  };

  return (
    <div className={'app-header'}>
      <div className={'app-header-container'}>
        <button className="header-home-button" onClick={() => navigateToHome()}>
          <img className={'header-logo'} src={logo} alt={'Hub of all things logo'} />
        </button>

        <span className={'header-flex-spacer'} />

        {props.loginBtn && (
          <button className="header-btn header-btn-border" onClick={() => navigateToLogin()}>
            Log in
          </button>
        )}

        {props.signupBtn && (
          <button className="header-btn header-btn-border" onClick={() => navigateToSignup()}>
            Create Account
          </button>
        )}

        <button className={'header-info-btn'} onClick={() => onWhatsHatPdaClicked()}>
          <i className="material-icons header-info-icon">help_outline</i>
        </button>

        <HatPdaDialog open={state.open} switchDialog={switchDialog} />
      </div>
    </div>
  );
};
